export default "__VITE_ASSET__847$$w0J__"